import React from 'react';
import { connect } from 'dva';
import ABSFlexibleForm, { IConfig } from '../ABSFlexibleForm';
import ABSPanel from '../ABSPanel';
import { setData, submit, cancel } from './utils';

interface IProps {
  defaultConfig?: IConfig[];
  dispatch: (params: any) => Promise<any>;
  filterId: number;
  loading: boolean;
  onSubmit: (value: any) => void;
}

interface IState {
  config: IConfig[];
}

class ABSFlexibleFilter extends React.Component<IProps, IState> {
  static defaultProps = {
    defaultConfig: [
      {
        type: 'input',
        title: '关键词',
        placeholder: '请输入关键词',
        name: 'keyword'
      },
      {
        type: 'date',
        title: '发行日期',
        placeholder: '请输入日期',
        name: 'closing_date',
        contentWidth: 131,
        date: {
          type: 'range'
        }
      },
      {
        type: 'date',
        title: '事件日期',
        placeholder: '请选择事件日期',
        contentWidth: 131,
        name: 'event',
        date: {
          type: 'range'
        }
      }
    ]
  };

  fForm: ABSFlexibleForm | null;
  data: any;

  state = {
    config: []
  };

  componentDidMount() {
    const { dispatch, filterId, defaultConfig = [] } = this.props;
    dispatch({
      type: 'global/filter',
      payload: { filter_type_id: filterId }
    }).then((data: any) => {
      this.data = data;
      setData({ onClick: this.onSubmit, onCancel: this.onCancel, formRef: this.fForm, defaultConfig, data, that: this });
    });
  }

  onSubmit = () => {
    const { onSubmit } = this.props;
    submit({ onSubmit, formRef: this.fForm });
  };

  onCancel = () => {
    const { defaultConfig = [] } = this.props;
    cancel({ onClick: this.onSubmit, onCancel: this.onCancel, formRef: this.fForm, defaultConfig, data: this.data, that: this });
  };

  render() {
    const { loading = false } = this.props;
    const { config } = this.state;
    return (
      <ABSPanel title="筛选条件" loading={loading}>
        <ABSFlexibleForm
          ref={view => {
            this.fForm = view;
          }}
          config={config}
          contentWidth={280}
          isWrap={true}
        />
      </ABSPanel>
    );
  }
}

export { IConfig };

function mapStateToProps(state: any) {
  const loading = state.loading.effects['global/filter'];
  return { loading };
}

export default connect(mapStateToProps)(ABSFlexibleFilter);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSFlexibleFilter/index.tsx